if (!customElements.get('pair-with-popup')) {
  customElements.define(
    'pair-with-popup',
    class PairWithPopup extends HTMLElement {
      constructor() {
        super()
        this.previouslyFocused = null
        this.handleClick = this.handleClick.bind(this)
        this.handleKeydown = this.handleKeydown.bind(this)
        this.addEventListener('click', this.handleClick)
        document.addEventListener('keydown', this.handleKeydown)
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.handleKeydown)
      }

      async showForCartResponse(response, offerTemplate = null) {
        if (offerTemplate) {
          this.open(offerTemplate.innerHTML)
          return
        }

        const addedItem = Array.isArray(response.items) ? response.items[0] : response
        const productHandle =
          addedItem?.handle ||
          addedItem?.url?.match(/\/products\/([^/?]+)/)?.[1]
        if (!productHandle) return

        try {
          const rootUrl = window.Shopify?.routes?.root || '/'
          const productUrl = `${rootUrl}products/${encodeURIComponent(productHandle)}?view=upsell`
          const result = await fetch(productUrl, { headers: { Accept: 'text/html' } })
          if (!result.ok) return

          const markup = (await result.text()).trim()
          if (!markup) return

          this.open(markup)
        } catch (error) {
          console.error('Unable to load paired product:', error)
        }
      }

      open(markup) {
        this.previouslyFocused = document.activeElement
        this.innerHTML = markup
        const cartDrawer = document.querySelector('cart-drawer')
        if (cartDrawer?.classList.contains('active')) cartDrawer.close()
        this.setAttribute('open', '')
        this.setAttribute('aria-hidden', 'false')
        document.body.classList.add('pair-with-popup-open')
        const dialog = this.querySelector('[data-pair-with-dialog]')
        const closeButton = this.querySelector('[data-pair-with-close]')
        if (typeof trapFocus === 'function') trapFocus(dialog, closeButton)
        else closeButton?.focus()
      }

      close() {
        if (!this.hasAttribute('open')) return
        this.removeAttribute('open')
        this.setAttribute('aria-hidden', 'true')
        document.body.classList.remove('pair-with-popup-open')
        if (typeof removeTrapFocus === 'function') removeTrapFocus()
        this.innerHTML = ''
        this.previouslyFocused?.focus()
      }

      handleClick(event) {
        if (event.target === this || event.target.closest('[data-pair-with-close]')) {
          this.close()
          return
        }

        const addButton = event.target.closest('[data-pair-with-add]')
        if (addButton) this.addPairedProduct(addButton)
      }

      handleKeydown(event) {
        if (event.key === 'Escape' && this.hasAttribute('open')) this.close()
      }

      async addPairedProduct(button) {
        if (button.disabled) return

        const errorElement = this.querySelector('[data-pair-with-error]')
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
        const payload = { items: [{ id: Number(button.dataset.variantId), quantity: 1 }] }

        if (cart) {
          payload.sections = cart.getSectionsToRender().map((section) => section.id)
          payload.sections_url = window.location.pathname
        }

        button.disabled = true
        button.classList.add('is-loading')
        errorElement?.setAttribute('hidden', '')

        try {
          const result = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          })
          const response = await result.json()
          if (!result.ok || response.status) throw new Error(response.description || 'Unable to add this item.')

          this.close()
          if (cart) cart.renderContents(response)
        } catch (error) {
          if (errorElement) {
            errorElement.textContent = error.message
            errorElement.removeAttribute('hidden')
          }
          button.disabled = false
          button.classList.remove('is-loading')
        }
      }
    }
  )
}
